import React, { useState, useMemo, useEffect } from "react";
// react plugin used to create DropdownMenu for selecting items
import Select from 'react-select'
import countryList from 'react-select-country-list'
import './SelectCountry.css'

const SelectCountry = (props) => {
  const [value, setValue] = useState()
  let options = useMemo(() => countryList().getData(), [])
  const institution = props.institution
  const setInstitution = props.setInstitution
  options = options.filter( item=> ["US", "CA", "GB"].includes(item.value))  

  const changeHandler = value => {
    setValue(value)
    institution['country'] = value.label
    setInstitution(institution)
  }

  useEffect(() => {
    options.forEach((item) => {
      if (item.label == props.country) {
        setValue(item)
      }
    })
  })

  return (
    <div >
      <Select
        className="form-control-alternative"
        isDisabled={props.formDisabled}
        options={options}
        value={value}
        id="input-country"
        classNamePrefix="selectCountry"
        onChange={changeHandler}
      />
    </div>
  );

}

export default SelectCountry;
